import {
  Box,
  Button,
  Center,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react'
import { faEye } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import React from 'react'
import TableLocal from '../../../../components/Table/TableLocal/TableLocal'
import { colors } from '../../../../utils/theme/styles'

const tradeColumns = [
  {
    Header: (props) => <Text {...props}>RUT_EMPRESA</Text>,
    accessor: 'sRutEmpresa',
    id: 'sRutEmpresa',
  },
  {
    Header: (props) => <Text {...props}>RUT_EMPLEADO</Text>,
    accessor: 'sRutColaborador',
    id: 'sRutColaborador',
  },
  {
    Header: (props) => <Text {...props}>RUT</Text>,
    accessor: '-',
    id: '-',
  },
  {
    Header: (props) => <Text {...props}>NOMBRE</Text>,
    accessor: 'sNombre',
    id: 'sNombre',
  },
  {
    Header: (props) => <Text {...props}>APELLIDO_PATERNO</Text>,
    accessor: 'sApellidoPaterno',
    id: 'sApellidoPaterno',
  },
  {
    Header: (props) => <Text {...props}>APELLIDO_MATERNO</Text>,
    accessor: 'sApellidoMaterno',
    id: 'sApellidoMaterno',
  },
  {
    Header: (props) => <Text {...props}>SUCURSAL</Text>,
    accessor: 'sSucursal',
    id: 'sSucursal',
  },
  {
    Header: (props) => <Text {...props}>CENTROCOSTO</Text>,
    accessor: 'sCentroCosto',
    id: 'sCentroCosto',
  },
  {
    Header: (props) => <Text {...props}>AÑOMES</Text>,
    accessor: 'sAñoMes',
    id: 'sAñoMes',
  },
  {
    Header: (props) => <Text {...props}>MONTO_RECARGA</Text>,
    accessor: 'sMontoRecarga',
    id: 'sMontoRecarga',
    type: 'currency',
  },
  {
    Header: (props) => <Text {...props}>Nº_RECARGA_AMIPASS</Text>,
    accessor: 'sAsignacion',
    id: 'sAsignacion',
  },
  {
    Header: (props) => <Text {...props}>MES_RECARGA</Text>,
    accessor: 'sMes',
    id: 'sMes',
  },
  {
    Header: (props) => <Text {...props}>AÑO_RECARGA</Text>,
    accessor: 'sAño',
    id: 'sAño',
  },
]
export default function PartnersBalanceReport({ data }) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <Button
        borderRadius={8}
        variant="ghost"
        onClick={onOpen}
        minHeight="56px"
        padding="0px 15px"
        backgroundColor="#fff"
        border="1px solid #D7D7D7"
      >
        <Box me={3}>
          <FontAwesomeIcon icon={faEye} />
        </Box>
        Ver informe
      </Button>

      <Modal size="4xl" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader bgColor={colors.secondary.base} color={colors.gray[50]}>
            Detalle de Recargas de Colaboradores
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody overflow="auto">
            <TableLocal
              data={data || []}
              columns={tradeColumns || []}
              tableStyles={{ overflow: 'auto' }}
            />
          </ModalBody>

          <ModalFooter w="100%">
            <Center w="100%">
              <Button w="324px" onClick={onClose}>
                Cerrar
              </Button>
            </Center>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

PartnersBalanceReport.propTypes = {
  data: PropTypes.array,
}
